export const SET_ESCALA_FUNCIONARIO = 'SET_ESCALA_FUNCIONARIO'


// WEBPACK FOOTER //
// ./src/store/modules/escalas/types.js